import { Response } from "react-select-async-paginate";
import AsyncPaginateBootstrap from "../react-select-bootstrap/AsyncPaginateBootstrap";
import { getList } from "../../api/generics";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import ProductBrand from "../../models/product-brand";

const RECORS_PER_SEARCH = 20;

type ProductBrandSelectProps = {
  value: ProductBrand | null;
  disabled?: boolean;
  onChange: (_: ProductBrand | null) => void;
};

const ProductBrandSelect: React.FC<ProductBrandSelectProps> = ({
  value,
  disabled,
  onChange,
}) => {
  const companyId = useSelector(
    (state: RootState) => state.company.data.company.id
  );
  const loadOptions = async (
    s: string,
    currentOpts: readonly (
      | ProductBrand
      | { options: ProductBrand[]; label?: string }
    )[]
  ): Promise<
    Response<ProductBrand, { options: ProductBrand[]; label?: string }, any>
  > => {
    let additionalParams: Map<string, string> | undefined = new Map<
      string,
      string
    >();

    additionalParams.set("company_id", companyId!.toString());

    if (s !== "") {
      additionalParams.set("search", s);
    }

    const dataPaginated = await getList<ProductBrand>(
      "/product_brands/",
      RECORS_PER_SEARCH,
      currentOpts.length,
      additionalParams
    );

    let newOpts: ProductBrand[] = [];
    let count = 0;

    if (dataPaginated.data !== undefined) {
      newOpts = dataPaginated.data.items;
      count = dataPaginated.data.count;
    }

    const hasMore = currentOpts.length + newOpts.length < count;

    return {
      options: newOpts,
      hasMore: hasMore,
    };
  };

  return (
    <AsyncPaginateBootstrap
      placeholder={"Marca"}
      onChange={onChange}
      isMulti={false}
      debounceTimeout={300}
      loadOptions={loadOptions}
      getOptionLabel={(option: ProductBrand) =>
        option.code ? `${option.name} (${option.code})` : `${option.name}`
      }
      getOptionValue={(option: ProductBrand) => `${option.id}`}
      noOptionsMessage={({ inputValue }: { inputValue: string }) =>
        inputValue
          ? "Sin resultados para la búsqueda"
          : "No hay marcas registradas"
      }
      value={value}
      isDisabled={disabled}
      isClearable={true}
    />
  );
};

export default ProductBrandSelect;
